import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { environment } from 'src/environments/environment';

export interface Product {
  id: number;
  name: string;
  default_code: string;
  list_price: number;
}

export interface ProductResponse {
  count: number;
  success: boolean;
  products: Product[];
  list_price: string;
  price_with_vat: string;
}
@Injectable({
  providedIn: 'root',
})
export class OdooProductsService {
  constructor(private functions: Functions) {}

  async getProducts() {
    const callable = httpsCallable<{ isProd: boolean }, ProductResponse>(
      this.functions,
      'get_products'
    );
    return callable({ isProd: environment.production });
  }

  async updateProduct(barcode: string, product: Product) {
    const callable = httpsCallable<
      { isProd: boolean; barcode: string; product: Product },
      ProductResponse
    >(this.functions, 'update_product');
    return callable({ isProd: environment.production, barcode, product });
  }
}
